// Copy and paste this into your JavaScript code to initialize the Firebase SDK.
// You will also need to load the Firebase SDK.
// See https://firebase.google.com/docs/web/setup for more details.

const firebaseConfig = {
  "projectId": "classyvisatour",
  "appId": "1:430519706083:web:c6b9eb1ba0c247a9dfc0d6",
  "databaseURL": "https://classyvisatour-default-rtdb.firebaseio.com",
  "storageBucket": "classyvisatour.appspot.com",
  "locationId": "us-central",
  "apiKey": "AIzaSyAkdq9QCg64hVwJ3n9X5Dv-d95sHYQFfEw",
  "authDomain": "classyvisatour.firebaseapp.com",
  "messagingSenderId": "430519706083"
};
export default firebaseConfig;

